import { MuiComponent } from "./type";
import * as Colors from "../colors";
import { PlaceholderGray } from "../colors";

export const MuiButton: MuiComponent<"MuiButton"> = {
  styleOverrides: {
    root: {
      borderRadius: '12px',
      padding: '9px 18px',
      maxHeight: '40px',
      gap: '8px',
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 500,
      textTransform: 'none',
      
      '&:disabled': {
        color: '#353A41',
        backgroundColor: '#353A4150',
      },

      '&:hover': {
        backgroundColor: '#3745AF',
      },

      '&:active': {
        backgroundColor: '#2B3587',
      },
    },
    outlined: {
      borderRadius: '12px',
      padding: '9px 24px',
      gap: '8px',
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 500,
      textTransform: 'none',
      border: `1px solid ${Colors.ButtonBorderGray}`,
      color: Colors.White,

      '&:hover': {
        border: `1px solid ${Colors.ButtonPurple}`,
        backgroundColor: '#2A2A2A',
      },
      
      '&:active': {
        border: `1px solid #7B81EC`,
        backgroundColor: '#CACEFC18',
      },
    },
    text: {
      padding: '0px',
      margin: '0px',
      color: Colors.White,
      fontSize: '14px',
      fontWeight: 500,
      textDecoration: 'none',

      '&:hover': {
        backgroundColor: 'transparent',
        textDecoration: 'none',
        color: Colors.Purple,
      },

      '& .MuiTouchRipple-root': {
        display: 'none !important',
      },
    },
  },
  variants: [
    {
      props: { color: 'primary' },
      style: {
        backgroundColor: Colors.Blue,
      },
    },
    {
      props: { color: 'secondary' },
      style: {
        backgroundColor: Colors.LightGray,
      },
    },
    {
      props: { color: 'warning', variant: 'contained' },
      style: {
        backgroundColor: Colors.Yellow,
        color: Colors.Black,
      },
    },
    {
      props: { color: 'warning', variant: 'outlined' },
      style: {
        color: Colors.Yellow,
        border: `1px solid ${Colors.Yellow}`,
        '&:hover': {
          border: `1px solid ${Colors.Yellow}`,
          backgroundColor: `${Colors.Yellow}1A`,
        },
      },
    },
    {
      props: { color: 'error', variant: 'contained' },
      style: {
        backgroundColor: Colors.DarkRed,
      },
    },
    {
      props: { color: 'error', variant: 'outlined' },
      style: {
        color: Colors.DarkRed,
        border: `1px solid ${Colors.DarkRed}`,
        '&:hover': {
          border: `1px solid ${Colors.DarkRed}`,
          backgroundColor: `${Colors.DarkRed}1A`,
        },
      },
    },
    {
      props: { variant: 'text' },
      style: {
        backgroundColor: 'transparent',
      },
    },
    { 
      props: { variant: 'outlined' },
      style: {
        backgroundColor: 'transparent',
      },
    },
    {
      props: { size: 'small' },
      style: {
        padding: '6px 14px',
        width: 'fit-content',
        fontSize: '12px',
        borderRadius: '20px',
        borderColor: Colors.LightGray,
      },
    },
  ],
};

export const MuiIconButton: MuiComponent<"MuiIconButton"> = {
  styleOverrides: {
    root: {
      color: PlaceholderGray,
      '&.Mui-disabled': {
        color: PlaceholderGray,
      },
    },
  },
};